import { requestBuilder } from '../../../http/RequestBuilder';

interface UseCreateLinkTokenOutput {
    linkToken: string;
    linkSource: string;
}

interface UseCreateLinkTokenBody {
    stytchId: string;
    redirectUri?: string;
}

const useCreateLinkToken = requestBuilder.mutation<
    UseCreateLinkTokenOutput,
    UseCreateLinkTokenBody
>({
    endpoint: '/api/external-account/link-token',
    method: 'POST',
});

export default useCreateLinkToken;
